define(["exports", "text!../../assets/ui.css", "hyperhtml", "./markdown", "../shortcut", "./pubsubhub"], function (_exports, _ui, _hyperhtml, _markdown, _shortcut, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ui = _exports.name = void 0;
  _ui = _interopRequireDefault(_ui);
  _hyperhtml = _interopRequireDefault(_hyperhtml);
  _shortcut = _interopRequireDefault(_shortcut);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["<div id='", "' class='respec-modal removeOnSave' role='dialog'>\n      <h3 id=\"", "\">", "</h3>\n      <div class='inside'>", "</div>\n    </div>"]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["<div id='respec-overlay' class='removeOnSave'></div>"]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["<li role=menuitem>", "</li>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["<button id=\"", "\" class=\"respec-option\" title=\"", "\">\n      <span class=\"respec-cmd-icon\">", "</span> ", "\u2026\n    </button>"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<ol class='", "'></ol>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<button id='", "' class='respec-info-button'>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<button id='respec-pill' disabled>ReSpec</button>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<ul id=respec-menu role=menu aria-labelledby='respec-pill' hidden></ul>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<div id='respec-ui' class='removeOnSave' hidden></div>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/ui"; // Opportunistically inserts the style, with the chance to reduce some FOUC

  _exports.name = name;
  const styleElement = document.createElement("style");
  styleElement.id = "respec-ui-styles";
  styleElement.textContent = _ui.default;
  styleElement.classList.add("removeOnSave");
  document.head.appendChild(styleElement);

  function ariaDecorate(elem, ariaMap) {
    if (!elem) {
      return;
    }

    Array.from(ariaMap).forEach(([name, value]) => {
      elem.setAttribute("aria-".concat(name), value);
    });
  }

  const respecUI = (0, _hyperhtml.default)(_templateObject());
  const menu = (0, _hyperhtml.default)(_templateObject2());
  let modal;
  let overlay;
  const errors = [];
  const warnings = [];
  const buttons = {};
  (0, _pubsubhub.sub)("start-all", () => document.body.prepend(respecUI), {
    once: true
  });
  (0, _pubsubhub.sub)("end-all", () => document.body.prepend(respecUI), {
    once: true
  });
  const respecPill = (0, _hyperhtml.default)(_templateObject3());
  respecUI.appendChild(respecPill);
  respecPill.addEventListener("click", e => {
    e.stopPropagation();

    if (menu.hidden) {
      menu.classList.remove("respec-hidden");
      menu.classList.add("respec-visible");
    } else {
      menu.classList.add("respec-hidden");
      menu.classList.remove("respec-visible");
    }

    respecPill.setAttribute("aria-expanded", String(menu.hidden));
    menu.hidden = !menu.hidden;
  });
  document.documentElement.addEventListener("click", () => {
    if (!menu.hidden) {
      menu.classList.remove("respec-visible");
      menu.classList.add("respec-hidden");
      menu.hidden = true;
    }
  });
  respecUI.appendChild(menu);
  const ariaMap = new Map([["controls", "respec-menu"], ["expanded", "false"], ["haspopup", "true"], ["label", "ReSpec Menu"]]);
  ariaDecorate(respecPill, ariaMap);

  function errWarn(msg, arr, butName, title) {
    arr.push(msg);

    if (!buttons.hasOwnProperty(butName)) {
      buttons[butName] = createWarnButton(butName, arr, title);
      respecUI.appendChild(buttons[butName]);
    }

    buttons[butName].textContent = arr.length;
  }

  function createWarnButton(butName, arr, title) {
    const buttonId = "respec-pill-".concat(butName);
    const button = (0, _hyperhtml.default)(_templateObject4(), buttonId);
    button.addEventListener("click", () => {
      button.setAttribute("aria-expanded", "true");
      const ol = (0, _hyperhtml.default)(_templateObject5(), "respec-".concat(butName, "-list"));

      for (const err of arr) {
        const fragment = document.createRange().createContextualFragment((0, _markdown.markdownToHtml)(err));
        const li = document.createElement("li"); // if it's only a single element, just copy the contents into li

        if (fragment.firstElementChild === fragment.lastElementChild) {
          li.append(...fragment.firstElementChild.childNodes); // Otherwise, take everything.
        } else {
          li.appendChild(fragment);
        }

        ol.appendChild(li);
      }

      ui.freshModal(title, ol, button);
    });
    const ariaMap = new Map([["expanded", "false"], ["haspopup", "true"], ["controls", "respec-pill-".concat(butName, "-modal")], ["label", "Document ".concat(title.toLowerCase())]]);
    ariaDecorate(button, ariaMap);
    return button;
  }

  const ui = {
    show() {
      try {
        respecUI.hidden = false;
      } catch (err) {
        console.error(err);
      }
    },

    hide() {
      respecUI.hidden = true;
    },

    enable() {
      respecPill.removeAttribute("disabled");
    },

    addCommand(label, handler, keyShort, icon) {
      icon = icon || "";
      const id = "respec-button-".concat(label.toLowerCase().replace(/\s+/, "-"));
      const button = (0, _hyperhtml.default)(_templateObject6(), id, keyShort, icon, label);
      const menuItem = (0, _hyperhtml.default)(_templateObject7(), button);
      menuItem.addEventListener("click", handler);
      menu.appendChild(menuItem);
      if (keyShort) _shortcut.default.add(keyShort, handler);
      return button;
    },

    error(msg) {
      errWarn(msg, errors, "error", "Errors");
    },

    warning(msg) {
      errWarn(msg, warnings, "warning", "Warnings");
    },

    closeModal(owner) {
      if (overlay) {
        overlay.classList.remove("respec-show-overlay");
        overlay.classList.add("respec-hide-overlay");
        overlay.addEventListener("transitionend", () => {
          overlay.remove();
          overlay = null;
        });
      }

      if (owner) {
        owner.setAttribute("aria-expanded", "false");
      }

      if (!modal) return;
      modal.remove();
      modal = null;
    },

    freshModal(title, content, currentOwner) {
      if (modal) modal.remove();
      if (overlay) overlay.remove();
      overlay = (0, _hyperhtml.default)(_templateObject8());
      const id = "".concat(currentOwner.id, "-modal");
      const headingId = "".concat(id, "-heading");
      modal = (0, _hyperhtml.default)(_templateObject9(), id, headingId, title, content);
      const ariaMap = new Map([["labelledby", headingId]]);
      ariaDecorate(modal, ariaMap);
      document.body.append(overlay, modal);
      overlay.addEventListener("click", () => this.closeModal(currentOwner));
      overlay.classList.toggle("respec-show-overlay");
      modal.hidden = false;
    }

  };
  _exports.ui = ui;

  _shortcut.default.add("Esc", () => ui.closeModal());

  _shortcut.default.add("Ctrl+Alt+Shift+E", () => {
    if (buttons.error) buttons.error.click();
  });

  _shortcut.default.add("Ctrl+Alt+Shift+W", () => {
    if (buttons.warning) buttons.warning.click();
  });

  window.respecUI = ui;
  (0, _pubsubhub.sub)("error", details => ui.error(details));
  (0, _pubsubhub.sub)("warn", details => ui.warning(details));
});
//# sourceMappingURL=ui.js.map